// extracted by mini-css-extract-plugin
export default {"wp-input":"WpInput_wp-input__e3FnB","tiny":"WpInput_tiny__0sLOg","medium":"WpInput_medium__l7r25","clear":"WpInput_clear__JvdIg","pill":"WpInput_pill__vd9Pc"};